export var PAN_TYPE;
(function (PAN_TYPE) {
    PAN_TYPE["RESIDENT_INDIVIDUAL_SELF"] = "RESIDENT_INDIVIDUAL_SELF";
    PAN_TYPE["RESIDENT_INDIVIDUAL_OTHER"] = "RESIDENT_INDIVIDUAL_OTHER";
    PAN_TYPE["LLP"] = "LLP";
    PAN_TYPE["HUF"] = "HUF";
    PAN_TYPE["PRIVATE_LIMITED"] = "PRIVATE_LIMITED";
    PAN_TYPE["INDIVIDUAL"] = "INDIVIDUAL";
    PAN_TYPE["SOLE_PROPRIETOR"] = "SOLE_PROPRIETOR";
    PAN_TYPE["PARTNERSHIP"] = "PARTNERSHIP";
    PAN_TYPE["OPC"] = "OPC";
    PAN_TYPE["OTHER"] = "OTHER";
})(PAN_TYPE || (PAN_TYPE = {}));
